module.exports = require('./helpers/bundle-url').getBundleURL('jKRPl') + "arrow-grey.c3c5e154.svg";